fccd-clear-all {
  button.clearall {
    white-space: nowrap;
  }
}
